import * as Scrivito from "scrivito";
import defaultFormInputAttributes from "../../_defaultFormAttributes";

const RadioboxWidget = Scrivito.provideWidgetClass("RadioboxWidget", {
  attributes: {
    ...defaultFormInputAttributes,
    radioButtons: ["widgetlist", { only: "RadioButtonWidget" }],
  },
  onlyInside: "FormPageWidget",
});

export default RadioboxWidget;
